import { render, staticRenderFns } from "./ListContactsBrain.vue?vue&type=template&id=60480830&scoped=true"
import script from "./ListContactsBrain.vue?vue&type=script&lang=js"
export * from "./ListContactsBrain.vue?vue&type=script&lang=js"
import style0 from "./ListContactsBrain.vue?vue&type=style&index=0&id=60480830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60480830",
  null
  
)

export default component.exports